// =============================================================================
// NAD+ Hero V2 Section Component
// =============================================================================

export class NADHeroV2 {
  private element: HTMLElement;
  private observers: Map<HTMLElement, IntersectionObserver> = new Map();

  constructor(element: HTMLElement) {
    this.element = element;
    this.init();
  }

  private init(): void {
    this.setupScrollAnimation();
  }

  /**
   * Add .animate-in to the section and its card elements as they become
   * visible, mirroring the nad-hero-section fade-in pattern
   */
  private setupScrollAnimation(): void {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            sectionObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    sectionObserver.observe(this.element);
    this.observers.set(this.element, sectionObserver);

    const elements = this.element.querySelectorAll<HTMLElement>(
      '.nad-hero-v2__text-block, .nad-hero-v2__cta, .nad-hero-v2__trust'
    );

    elements.forEach((element) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('animate-in');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -30px 0px'
        }
      );

      observer.observe(element);
      this.observers.set(element, observer);
    });
  }

  public destroy(): void {
    this.observers.forEach((observer, element) => {
      observer.disconnect();
      element.classList.remove('animate-in');
    });
    this.observers.clear();
  }

  static initializeAll(): void {
    document.querySelectorAll<HTMLElement>('.nad-hero-v2')
      .forEach(el => {
        if (!(el as any)._nadComponentInstance) {
          (el as any)._nadComponentInstance = new NADHeroV2(el);
        }
      });
  }
}
